import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const DraftLozenge: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DraftLozenge" */ './DraftLozenge.tsx'))
			.DraftLozenge,
});
